import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Offcanvas, Button } from "react-bootstrap";
import MaintennanceDropDownFilter from "../../../../components/FilterBox/MaintenanceFilter/MaintennanceDropDownFilter";
import MaintenanceTable from "../../../../components/Tables/MaintenanceTable";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";

import { format } from "date-fns";

import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import {
  MachineGrpMonthlyCon,
  MachineGrpMonthlyConFun,
  StoreFilters,
} from "../../../../Redux/Slice/Maintenance/MaintenanceSlice";
import { Loader } from "../../../../components/Loader/Loader";
import MaintenanceFilterBox from "../../../../components/FilterBox/MaintenanceFilter/MaintenanceFilter";
import { FiMenu } from "react-icons/fi";
import { useTheme } from "../../../../Themecontext/Themecontext";
import MaintenanceCelender from "../../../../components/Calendar/MaintenanceCelender";
import Calendar from "react-calendar";

export const MachineGroupMonthWiseConsumption = () => {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { StoreFiltersdata, MachineGrpMonthlyCondata } = useSelector(
    (state) => state.MaintenanceSlice,
  );

  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "MAINTENANCESTORE",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "MAINTENANCESTOREDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const FinancialYear = Cookies.get("FinancialYear");
  const Firm = Cookies.get("Firm");
  const [loading, setLoading] = useState(true);

  const [showFilter, setShowFilter] = useState(false);

  // Selected IDs
  const [bookNameIds, setBookNameIds] = useState([]);
  const [machineGroupIds, setMachineGroupIds] = useState([]);

  // Search Values
  const [bookNameSearch, setBookNameSearch] = useState("");
  const [machineGroupSearch, setMachineGroupSearch] = useState("");

  const handleShow = () => setShowFilter(true);
  const handleClose = () => setShowFilter(false);
  const [showDatePicker, setShowDatePicker] = useState(false);

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return "";
    return format(new Date(date), "yyyy-MM-dd");
  };

  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const isApiCalled = useRef(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      if (isApiCalled.current) return;

      isApiCalled.current = true;

      try {
        await dispatch(StoreFilters());

        await dispatch(
          MachineGrpMonthlyCon({
            firm: Firm,
            Acyear: FinancialYear,
            StartDate: safeFormat(startDate),
            EndDate: safeFormat(endDate),
          }),
        );
      } finally {
        setLoading(false);
      }
    };

    if (startDate && endDate) {
      fetchData();
    }
  }, [startDate, endDate]);

  const [filter, setFilter] = useState({
    bookName: [],
    machineGroup: [],
  });

  const [search, setSearch] = useState({
    bookName: "",
    machineGroup: "",
  });

  const bookNameList =
    StoreFiltersdata?.issueBooks?.map((item) => ({
      label: item.BookTypeName,
      value: item.BookTypeId,
    })) || [];

  const machineGroupList =
    StoreFiltersdata?.MachineGroup?.map((item) => ({
      label: item.MachineGroupMstName,
      value: item.MachineGroupMstID,
    })) || [];

  const toggleItem = (type, item) => {
    setFilter((prev) => {
      const selected = prev[type];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };

  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilter((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };
  const columns = [
    { label: "Chart", key: "charts" },
    {
      label: "Sr. No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Machine Group",
      key: "MachineGroup",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Total", key: "Total", align: "right", format: "true" },
    { label: "Apr", key: "April", align: "right", format: "true" },
    { label: "May", key: "May", align: "right", format: "true" },
    { label: "Jun", key: "June", align: "right", format: "true" },
    { label: "Jul", key: "July", align: "right", format: "true" },
    { label: "Aug", key: "August", align: "right", format: "true" },
    { label: "Sep", key: "September", align: "right", format: "true" },
    { label: "Oct", key: "October", align: "right", format: "true" },
    { label: "Nov", key: "November", align: "right", format: "true" },
    { label: "Dec", key: "December", align: "right", format: "true" },
    { label: "Jan", key: "January", align: "right", format: "true" },
    { label: "Feb", key: "February", align: "right", format: "true" },
    { label: "Mar", key: "March", align: "right", format: "true" },
  ];

  const initialData = (MachineGrpMonthlyCondata?.Data || []).map((row) => ({
    chart: "true",
    MachineGroup: row.MachineGroupMstName,

    April: row.AprilConsAmt,
    May: row.MayConsAmt,
    June: row.JunConsAmt,
    July: row.JulyConsAmt,
    August: row.AugConsAmt,
    September: row.SepConsAmt,
    October: row.OctConsAmt,
    November: row.NovConsAmt,
    December: row.DecConsAmt,
    January: row.JanConsAmt,
    February: row.FebConsAmt,
    March: row.MarchConsAmt,
    Total: row.TotalAmt,
  }));
  const handleSubmit = () => {
    dispatch(MachineGrpMonthlyConFun());

    dispatch(
      MachineGrpMonthlyCon({
        firm: Firm,
        Acyear: FinancialYear,
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
        BookIDs: filter.bookName.toString(),
        MachineGroupMstIDs: filter.machineGroup.toString(),
      }),
    );

    setShowFilter(false)
  };

  const handleSubmit1 = () => {

    dispatch(MachineGrpMonthlyConFun());

    dispatch(
      MachineGrpMonthlyCon({
        firm: Firm,
        Acyear: FinancialYear,
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
        BookIDs: bookNameIds.toString(),
        MachineGroupMstIDs: machineGroupIds.toString(),
      }),
    );
  };

  if (!StoreFiltersdata) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!MachineGrpMonthlyCondata || MachineGrpMonthlyCondata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }
  return (
    <div
      style={{
        padding: "16px",
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
        minHeight: "100vh",
      }}
    >
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={handleShow}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour11,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>

      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
        }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title
            style={{ color: isdark === "light" ? "#000" : "#fff" }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <div>
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour8
                      : iscolourDark?.Colour11,
                  padding: "13px 20px",
                  borderRadius: "12px 12px 0px 0px",
                }}
              >
                <h3
                  style={{
                    fontWeight: "700",
                    fontSize: "18px",
                    margin: 0,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1,
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  {" "}
                  Date Range
                </h3>
              </div>
              <div
                style={{
                  border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                  padding: "15px",
                  marginBottom: "15px",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour3,
                  borderRadius: "0px 0px 12px 12px",
                }}
              >
                <div
                  onClick={() => setShowDatePicker(true)}
                  style={{
                    marginTop: "8px",
                    padding: "10px",
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                    borderRadius: "10px",
                    cursor: "pointer",
                    textAlign: "center",
                    color: isdark === "light" ? "#000" : "#FFF",
                  }}
                >
                  {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                    ? `${format(dateRange[0].startDate, "yyyy-MM-dd")} - ${format(dateRange[0].endDate, "yyyy-MM-dd")}`
                    : "Select Date Range"}
                </div>
              </div>
            </div>
            <MaintenanceFilterBox
              title="Book Name"
              items={bookNameList}
              search={search.bookName}
              setSearch={(val) => handleSearch("bookName", val)}
              selectedItems={filter.bookName}
              toggleItem={(item) => toggleItem("bookName", item)}
              selectAll={() => selectAll("bookName", bookNameList)}
            />

            <MaintenanceFilterBox
              title="Machine Group"
              items={machineGroupList}
              search={search.machineGroup}
              setSearch={(val) => handleSearch("machineGroup", val)}
              selectedItems={filter.machineGroup}
              toggleItem={(item) => toggleItem("machineGroup", item)}
              selectAll={() => selectAll("machineGroup", machineGroupList)}
            />

            <button
              onClick={handleSubmit}
              style={{
                width: "100%",
                // height: "45px",
                padding: "12px",
                borderRadius: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour11,
                color: "#fff",
                fontWeight: "700",
                border: "none",
              }}
            >
              Apply Filter
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      {/* 🔷 FILTER BOX */}
      <div
        className="d-none d-lg-block"
        style={{
          padding: "15px",
          borderRadius: "12px",
          border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour8
            }`,
          marginBottom: "20px",
        }}
      >
        <Row className="align-items-end g-2">
          <Col xl={3} lg={6}>
            <div>
              <h3
                style={{
                  color: isdark === "light" ? iscolour?.Colour11 : "#fff",
                  fontWeight: "700",
                  fontSize: "13px",
                  marginBottom: "5px",
                }}
              >
                Date Range
              </h3>
            </div>
            <div>
              <div
                onClick={() => setShowDatePicker(true)}
                className="date"
                style={{
                  padding: " 12px 20px",
                  borderRadius: "12px",
                  cursor: "pointer",
                  textAlign: "center",
                  border: `1px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7}`,
                  color: isdark === "light" ? "#000" : "#fff",
                }}
              >
                {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? `${format(dateRange[0].startDate, "dd/MM/yyyy")} - ${format(dateRange[0].endDate, "dd/MM/yyyy")}`
                  : "Select Date Range"}
              </div>
            </div>
          </Col>
          {/* Book Name */}
          <Col xl={3} lg={6}>
            <MaintennanceDropDownFilter
              label="Book Name"
              data={bookNameList}
              selectedValue={bookNameSearch}
              setSelectedValue={setBookNameSearch}
              selectedId={bookNameIds}
              setSelectedId={setBookNameIds}
              placeholder="Select Book"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          {/* Machine Group */}
          <Col xl={3} lg={6}>
            <MaintennanceDropDownFilter
              label="Machine Group"
              data={machineGroupList}
              selectedValue={machineGroupSearch}
              setSelectedValue={setMachineGroupSearch}
              selectedId={machineGroupIds}
              setSelectedId={setMachineGroupIds}
              placeholder="Select Machine Group"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          {/* Button */}
          <Col xl={3} lg={6}>
            <button
              onClick={handleSubmit1}
              style={{
                width: "100%",
                // height: "45px",
                padding: "12px",
                borderRadius: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour11,
                color: "#fff",
                fontWeight: "700",
                border: "none",
              }}
            >
              Apply Filter
            </button>
          </Col>
        </Row>
      </div>

      {/* 🔷 TABLE */}
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
        }}
      >
        <div
          style={{
            padding: "14px",
            background:
              isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour11,
            color: "#fff",
            fontWeight: "600",
            fontSize: "18px",
            margin: 0,
            letterSpacing: "1px",
          }}
        >
          MACHINEGROUP MOTHWISE CONSUMPTION
        </div>
        
        <MaintenanceTable columns={columns} data={initialData} />
      </div>
      {/* 🔷 DATE PICKER MODAL */}
      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <MaintenanceCelender
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour8
                      : iscolourDark?.Colour11,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MachineGroupMonthWiseConsumption;
